<script setup>
import { trustItems } from '../../config/pageData.js';
</script>

<template>
  <section class="m-trust">
    <div
      v-for="(item, i) in trustItems"
      :key="i"
      class="m-trust-item"
    >
      <b class="m-trust-title">{{ item.icon }} {{ item.title }}</b>
      <p class="m-trust-sub">{{ item.sub }}</p>
    </div>
  </section>
</template>

<style scoped lang="scss">
.m-trust {
  background: #efe8d8;
  border-bottom: 1px solid #e2d9c4;
  padding: 52px 32px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  text-align: center;
}

.m-trust-title {
  display: block;
  font-size: 32px;
  color: #16241d;
}

.m-trust-sub {
  font-size: 26px;
  color: #6f6a5c;
  margin-top: 4px;
}
</style>
